import { catalog, plural } from '@nolens/i18n';

/** Estrutura da app: barra lateral, barra de topo, pesquisa, «Gravar» e primeiros passos. */
export const shellText = catalog(
  {
    // Barra lateral
    home: 'Home',
    myGuides: 'My guides',
    admin: 'Admin',
    search: 'Search',
    searchGuides: 'Search guides',
    switchSpace: 'Switch space',
    spaces: 'Spaces',
    newTeam: 'New team',
    guides: 'Guides',
    stats: 'Statistics',
    members: 'Members',
    settings: 'Settings',
    brand: 'Brand',
    savings: 'Savings',
    general: 'General',
    recordingRules: 'Recordings',
    plan: 'Plan and usage',
    backFromSettings: 'Back to the space',
    yourAccount: 'Your account',
    invite: 'Invite people',
    createTeam: 'Create a team',
    account: 'Account',
    extension: 'Extension',
    macApp: 'Mac app',
    signOut: 'Sign out',
    menu: 'Menu',
    sidebar: 'Main menu',
    hideSidebar: 'Hide the sidebar',
    showSidebar: 'Show the sidebar',
    breadcrumb: 'You are here',
    personalSpace: 'Personal space',
    team: 'Team',
    guidesCount: (n: number) => `${n} ${plural('en', n, { one: 'guide', other: 'guides' })}`,
    // Barra de topo
    record: 'Record',
    tryPro: 'Try Pro',
    seePlans: 'See plans',
    // Gravar
    recordTitle: 'Record a guide',
    recordChecking: 'Looking for the extension…',
    recordMissing:
      'Recording happens in the Nolens Guides extension for Chrome. Install it to record your first guide.',
    recordUnlinked:
      'The extension is installed but not connected to this account. Connect it to record.',
    recordStep1: 'Open the page where the process starts.',
    recordStep2: 'Click the Nolens Guides icon in the Chrome toolbar and “Start recording”.',
    recordStep3: 'Do the process once. When you click “Finish”, the guide opens here.',
    installExtension: 'Install the extension',
    connectExtension: 'Connect the extension',
    close: 'Close',
    // Pesquisa
    searchPlaceholder: 'Guide title or description…',
    searchHint: 'Search the guides in all your spaces.',
    searchNone: (q: string) => `No guides with “${q}”.`,
    searchResults: 'Results',
    untitled: 'Untitled',
    // Primeiros passos
    gettingStarted: 'Getting started',
    gettingStartedHint: 'A few steps to get the most out of Nolens Guides.',
    progress: (done: number, total: number) => `${done} of ${total}`,
    stepInstall: 'Install the extension',
    stepLink: 'Connect it to this account',
    stepRecord: 'Record your first guide',
    stepTeam: 'Create a team',
    stepInvite: 'Invite someone to a team',
    stepBrand: 'Set up a brand kit',
    done: 'Done',
  },
  {
    'pt-PT': {
      home: 'Início',
      myGuides: 'Os meus guias',
      admin: 'Administração',
      search: 'Procurar',
      searchGuides: 'Procurar guias',
      switchSpace: 'Mudar de espaço',
      spaces: 'Espaços',
      newTeam: 'Nova equipa',
      guides: 'Guias',
      stats: 'Estatísticas',
      members: 'Membros',
      settings: 'Definições',
      brand: 'Marca',
      savings: 'Poupança',
      general: 'Geral',
      recordingRules: 'Gravações',
      plan: 'Plano e utilização',
      backFromSettings: 'Voltar ao espaço',
      yourAccount: 'A sua conta',
      invite: 'Convidar pessoas',
      createTeam: 'Criar uma equipa',
      account: 'Conta',
      extension: 'Extensão',
      macApp: 'App para Mac',
      signOut: 'Sair',
      menu: 'Menu',
      sidebar: 'Menu principal',
      hideSidebar: 'Esconder a barra lateral',
      showSidebar: 'Mostrar a barra lateral',
      breadcrumb: 'Está aqui',
      personalSpace: 'Espaço pessoal',
      team: 'Equipa',
      guidesCount: (n) => `${n} ${plural('pt-PT', n, { one: 'guia', other: 'guias' })}`,
      record: 'Gravar',
      tryPro: 'Experimentar o Pro',
      seePlans: 'Ver planos',
      recordTitle: 'Gravar um guia',
      recordChecking: 'À procura da extensão…',
      recordMissing:
        'A gravação faz-se na extensão Nolens Guides para o Chrome. Instale-a para gravar o seu primeiro guia.',
      recordUnlinked:
        'A extensão está instalada, mas não está ligada a esta conta. Ligue-a para gravar.',
      recordStep1: 'Abra a página onde o processo começa.',
      recordStep2: 'Clique no ícone Nolens Guides na barra do Chrome e em «Começar a gravar».',
      recordStep3: 'Faça o processo uma vez. Quando carregar em «Concluir», o guia abre aqui.',
      installExtension: 'Instalar a extensão',
      connectExtension: 'Ligar a extensão',
      close: 'Fechar',
      searchPlaceholder: 'Título ou descrição do guia…',
      searchHint: 'Procure nos guias de todos os seus espaços.',
      searchNone: (q) => `Nenhum guia com «${q}».`,
      searchResults: 'Resultados',
      untitled: 'Sem título',
      gettingStarted: 'Primeiros passos',
      gettingStartedHint: 'Alguns passos para tirar o máximo do Nolens Guides.',
      progress: (done, total) => `${done} de ${total}`,
      stepInstall: 'Instalar a extensão',
      stepLink: 'Ligá-la a esta conta',
      stepRecord: 'Gravar o primeiro guia',
      stepTeam: 'Criar uma equipa',
      stepInvite: 'Convidar alguém para uma equipa',
      stepBrand: 'Personalizar um kit de marca',
      done: 'Feito',
    },
  },
);
